import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Service } from 'src/app/shared/models/service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';

@Component({
  selector: 'app-add-service',
  templateUrl: './add-service.component.html',
  styleUrl: './add-service.component.scss'
})

export class AddServiceComponent {


  constructor(
    private modalService: NgbModal,

    private paramService:ParameterService,
    private messageService :MessageService,
    private ngxService: NgxUiLoaderService,
    private fetchService: FecthDataService,
    
  ) { }


  ngOnInit(){
    this.fetchData();
  }
  close(){

    this.modalService.dismissAll();
  }

  item: Service= new Service()

  directionItems :any=[];
  addItems(){
    if (!this.item.canSave()) {
      
      this.messageService.add({ severity: 'info', summary: '', detail: this.item.getErrorMessage() });
      return;
    }
    this.ngxService.start();
    this.paramService.addService(this.item).subscribe(
      (response:any)=>{
        ////console.log("la reponse du webservice",response);
        this.messageService.add({ severity: 'success', summary: '', detail: response.message });
        this.modalService.dismissAll();
    this.ngxService.stop();
    this.fetchService.notifySeriviceCreated();

      },
      (error:any)=>{
        ////console.log("une erreur est survenu",error);
        this.messageService.add({ severity: 'error', summary: '', detail: error.error.message });

        this.modalService.dismissAll();
    this.ngxService.stop();

      }
    )
  }
  fetchData() {
    this.paramService.fetchDataDirection().subscribe(
      (response:any)=>{
        this.directionItems = response.data;
        ////console.log("this.actionData",this.serviceData);
      },
      (error)=>{
        ////console.log("une erreur est survenu",error);
        
      }
      
    ) ;
  }

}